// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9602) return "static/chunks/9602.dd4904bce620fa4d.js";
	if (chunkId === 1437) return "static/chunks/1437.e4910cab635c99fc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"131":"0ec4b888f7a53781","223":"895289da608a7400","1429":"c533635409adeeab","3733":"1e17a17cc44c5bf7","4743":"ace8a82aec41ea83","7708":"6e06bd3e2d57a852","9814":"dbbb71e5fbd0facd"}[chunkId] + ".js";
};